import { categories } from "@/mocks/opinion";

const NAV_LINKS = [
  { id: "hot", label: "今日热榜" },
  { id: "comments", label: "热门热评" },
  { id: "debate", label: "争论焦点" },
  { id: "read", label: "专题精选" },
  { id: "faq", label: "常见问题" },
  { id: "about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-accent-900 text-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 pt-12 md:pt-14 pb-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* brand */}
          <div>
            <a href="#top" className="flex items-center gap-2.5" aria-label="九一吃瓜">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-400 text-accent-950">
                <i className="ri-message-3-fill text-lg" aria-hidden="true"></i>
              </span>
              <span>
                <span className="block font-heading text-lg font-bold text-background-50">九一吃瓜</span>
                <span className="block text-xs text-background-200/80">评论区风向标</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-200/85">
              把评论区讲给你听。还原网友热评、观点与争论焦点，帮你快速掌握舆论脉络，少一点被带节奏，多一点独立思考。
            </p>
          </div>

          {/* nav */}
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-secondary-300">栏目导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-sm text-background-100/85 transition-colors hover:text-secondary-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* topics */}
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-secondary-300">话题分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.name}>
                  <a href="#topic" className="inline-flex items-center gap-2 text-sm text-background-100/85 transition-colors hover:text-secondary-300">
                    <i className={`${c.icon} text-accent-200`} aria-hidden="true"></i>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* contact */}
          <div>
            <h3 className="font-heading text-sm font-bold uppercase tracking-widest text-secondary-300">保持联系</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-100/85">
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-secondary-300" aria-hidden="true"></i>
                hello@jiuyi-chigua.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-feedback-line text-secondary-300" aria-hidden="true"></i>
                欢迎投稿与纠错
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2">
              {[
                { icon: "ri-wechat-line", label: "微信公众号" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-rss-line", label: "RSS" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#contact"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-100/20 text-background-100/80 transition-colors hover:border-secondary-400 hover:text-secondary-300"
                >
                  <i className={`${s.icon} text-lg`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-200/70">
            © {new Date().getFullYear()} 九一吃瓜 · 观点整理仅供参考，不代表本平台立场。
          </p>
          <p className="text-xs text-background-200/70">
            尊重原创 · 理性讨论 · 让每一种声音都被看见
          </p>
        </div>
      </div>
    </footer>
  );
}